import { superadminFetch } from './dataProvider';

/**
 * VendoIQ's own Zoho OAuth app credentials, managed in the console
 * (viq-backend: GET/PUT /v1/superadmin/crm-apps/zoho). The client secret is
 * write-only: the backend never returns it.
 *
 * Console-only on purpose: `integrationsApi`'s shape is the shared
 * `packages/screens` contract the portal's screens use too.
 */
export interface ZohoAppStatus {
  configured: boolean;
  clientId: string | null;
  updatedAt: string | null;
}

export interface ZohoAppSaveBody {
  clientId: string;
  clientSecret: string;
}

const ZOHO_APP_PATH = '/v1/superadmin/crm-apps/zoho';

export function getZohoApp(): Promise<ZohoAppStatus> {
  return superadminFetch<ZohoAppStatus>(ZOHO_APP_PATH);
}

export function putZohoApp(body: ZohoAppSaveBody): Promise<ZohoAppStatus> {
  return superadminFetch<ZohoAppStatus>(ZOHO_APP_PATH, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}
